// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content_wrapper__2-Du2","title":"Content_title__22W9s","desc":"Content_desc__3xcqG"};